var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-0.5 opacity-100",class:_vm.contrast ? 'bg-white' : 'bg-black',style:(_vm.percentageCount)})}
var staticRenderFns = []

export { render, staticRenderFns }